/**
 * PlusRoundedEndsIcon component - renders a plus with rounded edges icon as SVG
 * @returns React component that renders the plus with rounded edges icon
 */
const PlusRoundedEndsIcon = () => {
  return (
    <svg
      width="16"
      height="15"
      viewBox="0 0 16 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 6.40039C13.5523 6.40039 14 6.89288 14 7.50039C14 8.1079 13.5523 8.60039 13 8.60039L3 8.60039C2.44771 8.60039 2 8.1079 2 7.50039C2 6.89288 2.44772 6.40039 3 6.40039L13 6.40039Z"
        fill="#616161"
      />
      <path
        d="M13 6.40039C13.5523 6.40039 14 6.89288 14 7.50039C14 8.1079 13.5523 8.60039 13 8.60039L3 8.60039C2.44771 8.60039 2 8.1079 2 7.50039C2 6.89288 2.44772 6.40039 3 6.40039L13 6.40039Z"
        fill="#616161"
      />
      <path
        d="M9.09961 12.5C9.09961 13.0523 8.60712 13.5 7.99961 13.5C7.3921 13.5 6.89961 13.0523 6.89961 12.5L6.89961 2.5C6.89961 1.94771 7.3921 1.5 7.99961 1.5C8.60712 1.5 9.09961 1.94772 9.09961 2.5L9.09961 12.5Z"
        fill="#616161"
      />
      <path
        d="M9.09961 12.5C9.09961 13.0523 8.60712 13.5 7.99961 13.5C7.3921 13.5 6.89961 13.0523 6.89961 12.5L6.89961 2.5C6.89961 1.94771 7.3921 1.5 7.99961 1.5C8.60712 1.5 9.09961 1.94772 9.09961 2.5L9.09961 12.5Z"
        fill="#616161"
      />
    </svg>
  );
};

export default PlusRoundedEndsIcon;
